// extracted by mini-css-extract-plugin
export default {"titleBar":"FrameTitleBar_titleBar__OB3lw","title":"FrameTitleBar_title__RsR+J","buttonGroup":"FrameTitleBar_buttonGroup__ocW8G"};